export default function Features()
{
    return <>
        <div className="features">
            <h1>about our oils</h1>
            <div className="features-section">
                <div className="features-container">
                    <div className="features-description">
                        <div className="feature-number">1</div>
                        <div className="features-column">
                            <h4>prevent heart attacks</h4>
                            <p>Olive oil is one of the healthiest types of fat around, so you should choose fats wisely</p>
                        </div>
                    </div>
                    <div className="features-description">
                        <div className="feature-number">2</div>
                        <div className="features-column">
                            <h4>Improves Your Memory</h4>
                            <p>Olive oils’ antioxidants have been shown reverse of disease-related memory deficits.</p>
                        </div>
                    </div>
                    <div className="features-description">
                        <div className="feature-number">3</div>
                        <div className="features-column">
                            <h4>Helps Fight Cancer</h4>
                            <p>The elements in olive oil can decrease the risk of breast cancer and its recurrence.</p>
                        </div>
                    </div>
                </div>
                <div className="features-container">
                <div className="features-description">
                        <div className="feature-number">4</div>
                        <div className="features-column">
                            <h4>Reduces Cholesterol Levels</h4>
                            <p>The health benefits of olive oil include lower cholesterol levels in the your blood.</p>
                        </div>
                    </div>
                    <div className="features-description">
                        <div className="feature-number">5</div>
                        <div className="features-column">
                            <h4>Helps Digestion</h4>
                            <p>Although high in calories, olive oil has shown to help reduce levels of obesity.</p>
                        </div>
                    </div>
                    <div className="features-description">
                        <div className="feature-number">6</div>
                        <div className="features-column">
                            <h4>Prevents Blood Clotting</h4>
                            <p>Olive oil can reduce the risk of heart attacks and stroke, also improve blood clotting.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
}